module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_sns_03-01700574196d8d94701489376ce3043f.jpg";